import * as React from 'react'

import {
  Box,
  Checkbox,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
} from '@mui/material'
import { visuallyHidden } from '@mui/utils'
import { useTheme } from '@material-ui/core'

function EnhancedTableHead(props) {
  const {
    order,
    orderBy,
    onRequestSort,
    headCells,
    handleCheckboxAllClick,
    rowCount,
    allId,
  } = props

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property)
  }
  const theme = useTheme();
  return (
    <TableHead style={{ position: "sticky", top: 0, zIndex: 8 }}>
      <TableRow>
        <TableCell scope="row" className="stickyCell stickyFirst" sx={{ background: theme.palette.thead }}
        >
          <Checkbox
            checked={rowCount > 0 && allId == rowCount ? true : false}
            onClick={(event) => handleCheckboxAllClick(event)}
            className="selectCheckbox"
            style={{ color: theme.palette.listItem }}

          />
        </TableCell>
        {headCells.map((headCell, index) => {
          // decide sticky class
          const classes = [""]; // default no class
          // if (index === 0) classes.push("stickyCell", "stickyFirst"); // 1st col
          if (index === 0) classes.push("stickyCell", "stickySecond"); // 2nd col
          if (index === 1) classes.push("stickyCell", "stickyName"); // 3rd col
          if (headCell.id === "action") classes.push("stickyCell", "stickyAction"); // last col by id

          return headCell?.activeIndexOnly ? (
            <TableCell
              key={index}
              align={headCell.align}
              // width={headCell?.width}
              sx={{ background: theme.palette.thead, color: theme.palette.listItem }}
              style={{ minWidth: headCell.minWidth, width: headCell?.width }}
              padding={headCell.disablePadding ? "none" : "normal"}
              sortDirection={orderBy === headCell.id ? order.toLowerCase() : false}
              className={classes.join(" ")}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                disabled={!headCell.sortable}
                direction={orderBy === headCell.id ? order.toLowerCase() : "asc"}
                onClick={createSortHandler(headCell.id)}
                sx={{
                  '&.Mui-active': {
                    color: theme.palette.listItem, // Change this to your desired active color
                  },
                  '& .MuiTableSortLabel-icon': {
                    color: theme.palette.listItem, // Icon color
                  }

                }}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <Box sx={visuallyHidden}>
                    {order === "desc" ? "sorted descending" : "sorted ascending"}
                  </Box>
                ) : null}
              </TableSortLabel>
            </TableCell>
          ) : (
            <TableCell
              key={index}
              align={headCell.align}
              style={{ minWidth: headCell.minWidth }}
              padding={headCell.disablePadding ? "none" : "normal"}
              sortDirection={orderBy === headCell.id ? order : false}
              className={classes.join(" ")}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                disabled={!headCell.sortable}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
                sx={{
                  '&.Mui-active': {
                    color: theme.palette.listItem, // Change this to your desired active color
                  },
                  '& .MuiTableSortLabel-icon': {
                    color: theme.palette.listItem, // Icon color
                  }

                }}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === "desc" ? "sorted descending" : "sorted ascending"}
                  </Box>
                ) : null}
              </TableSortLabel>
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  )
}

export default EnhancedTableHead
